import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorProcessorService {
  constructor() { }

  static getErrorFromErrorResponse(err) {
    if (err.error.errors) {
      return err.error.errors[0].message;
    } else if (err.error.string) {
      return err.error.string;
    }

    return err.message;
  }

  static getErrorsArrayFromErrorResponse(err) {
    if (err.error.errors) {
      return err.error.errors.map((formError: {message: string}) => {
        return formError.message;
      });
    } else if (err.error.string) {
      return [err.error.string];
    }

    return [err.message];
  }

  static isNotFoundErrorResponse(err): boolean {
    if (err && err.status && err.status === 404) {
      return true;
    }

    return false;
  }

  static isSafePalyErrorResponse(err): boolean {
    const safePlaingErrorCodes = [8851, 8852, 8853, 8854, 8861, 8862];

    if (err && err.status && err.status === 400 && safePlaingErrorCodes.includes(err.error.code)) {
      return true;
    }
    return false;
  }
}
